import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import LatestAddress from './components/LatestAddress';
import FeaturesSection from './components/FeaturesSection';
import StepsSection from './components/StepsSection';
import QuickLinks from './components/QuickLinks';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '禁漫天堂 JMComic 官方指南',
    url: 'https://jmcomic-guide.com/',
    description: '禁漫天堂 JMComic 官方入口与使用指南，最新访问地址、注册登录方法、漫画分类导览及常见问题解答。',
    inLanguage: 'zh-Hans',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '禁漫天堂 JMComic 的最新访问地址是什么？', acceptedAnswer: { '@type': 'Answer', text: '禁漫天堂 JMComic 最新官方入口地址为 jmcomic2.moe。如遇访问问题，我们也提供多个备用镜像站：jmcomic1.moe、jmcomic3.moe。建议您收藏本页面，我们将持续更新最新可用的访问地址信息。' } },
      { '@type': 'Question', name: '如何注册禁漫天堂 JMComic 账号？', acceptedAnswer: { '@type': 'Answer', text: '进入禁漫天堂官网后，点击右上角的"注册"按钮，填写您的邮箱地址或手机号码，设置登录密码，接收并输入验证码即可完成注册。' } },
      { '@type': 'Question', name: '禁漫天堂是否支持漫画下载？', acceptedAnswer: { '@type': 'Answer', text: '是的，禁漫天堂 JMComic 支持漫画章节离线下载功能。在漫画详情页点击下载按钮即可将章节保存至本地。' } },
      { '@type': 'Question', name: '禁漫天堂有哪些漫画分类？', acceptedAnswer: { '@type': 'Answer', text: '禁漫天堂提供丰富的漫画分类体系，主要包括：热血冒险、恋爱校园、悬疑推理、搞笑日常、奇幻魔法、科幻未来、恐怖惊悚、武侠古风、都市职场等多种类型。' } },
      { '@type': 'Question', name: '为什么有时无法访问禁漫天堂？', acceptedAnswer: { '@type': 'Answer', text: '偶尔无法访问通常是由于网络波动或域名变更导致。解决方法包括尝试镜像站地址、清除浏览器缓存、切换网络环境或使用VPN工具。' } },
    ],
  };

  return (
    <>
      <SEOHead
        title="禁漫天堂 JMComic 官方入口与使用指南 - 最新访问地址与完整教程"
        description="禁漫天堂 JMComic 官方入口与使用指南，为您提供禁漫天堂最新访问地址、注册登录方法、漫画分类导览及常见问题解答。快速找到禁漫天堂入口，畅享丰富漫画资源与流畅阅读体验。"
        keywords="禁漫天堂,jmcomic最新地址,禁漫天堂入口,禁漫天堂注册登录,禁漫天堂镜像站,禁漫漫画下载,jmcomic官网访问"
        canonicalUrl="https://jmcomic-guide.com/"
      />
      <SchemaOrg schema={homeSchema} />
      <SchemaOrg schema={faqSchema} />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <LatestAddress />
          <FeaturesSection />
          <StepsSection />
          <QuickLinks />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}